import { mergeAttributes, Node, ReactNodeViewRenderer } from "@tiptap/react"

import { DocumentAttachmentNodeComponent } from "../DocumentAttachmentNode/Component"

export const OvermapNode = Node.create({
	name: "OvermapNode",
	group: "block",
	selectable: true,
	addAttributes() {
		return {
			uuid: {
				default: null,
			},
			model: "DocumentAttachment",
		}
	},
	parseHTML() {
		return [
			{
				tag: "overmap-node",
			},
		]
	},
	renderHTML({ HTMLAttributes }) {
		return ["overmap-node", mergeAttributes(HTMLAttributes)]
	},
	addNodeView() {
		return ReactNodeViewRenderer(DocumentAttachmentNodeComponent)
	},
})
